import { render, staticRenderFns } from "./UpsPackageSummaryPrint.vue?vue&type=template&id=822933b8&scoped=true"
import script from "./UpsPackageSummaryPrint.vue?vue&type=script&lang=ts"
export * from "./UpsPackageSummaryPrint.vue?vue&type=script&lang=ts"
import style0 from "./UpsPackageSummaryPrint.vue?vue&type=style&index=0&id=822933b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822933b8",
  null
  
)

export default component.exports